import { makeStyles } from "@material-ui/core";
import { h4Medium, h5Medium, h6Regular } from "../../../shared/typography";
import { pointer } from "../../../shared/mixins";

export const useStyles = makeStyles(() => ({
  container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "100vh",
  },
  title: {
    ...h4Medium,
  },
  card: {
    background: "#FFF",
    width: "100%",
    maxWidth: 350,
    boxSizing: "border-box",
    padding: 24,
    borderRadius: 16,
    marginTop: 15,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
  },
  message: {
    ...h6Regular,
  },
  continueButton: {
    ...h5Medium,
    ...pointer,
    width: "100%",
    border: "none",
    borderRadius: 16,
    height: 36,
    textAlign: "center",
    background: "#80BB34",
    color: "#FFFFFF",
    marginTop: 24,
    "&:disabled": {
      opacity: 0.5,
      cursor: "default",
    },
  },
}));
